<template>
  <v-menu
    v-model="showMenu"
    offset-y
    bottom
    nudgeBottom="10"
    :min-width="240"
    :max-width="300"
    :max-height="350"
    transition="scale-transition"
    content-class="records-tags__content"
    :close-on-content-click="false"
  >
    <v-btn
      class="records-tags__btn"
      :class="{ selected: selectedE }"
      depressed
      color="grey lighten-3"
      slot="activator"
      ><SvgIcon class="mr-2" width="24" height="24" icon="CrossServiceIcon" />
      {{ $t('select_services') }}
    </v-btn>

    <SelectServices
      v-if="showMenu"
      :id="selectedServices"
      :items="services"
      @onChange="handleChange"
      @onClose="showMenu = false"
    />
  </v-menu>
</template>

<script>
import SelectServices from '@/components/records_v2/SelectServices'

export default {
  name: 'RecordsServices',
  props: {
    selectedServices: {
      type: Array,
      default: () => []
    },
    services: {
      type: Array,
      default: () => []
    },
    onChange: {
      type: Function
    }
  },
  components: {
    SelectServices
  },
  computed: {
    selectedE() {
      if (this.selectedServices) {
        return this.selectedServices.length > 0
      } else return false
    }
  },
  data() {
    return {
      showMenu: false
    }
  },
  methods: {
    handleChange(selected) {
      this.showMenu = false
      this.$emit('onChange', selected)
    }
  }
}
</script>

<style lang="scss" scoped>
.records-tags__btn {
  border-radius: 41px;
  text-transform: none;
  font-weight: normal;

  .tag-icon {
    margin-right: 4px;
  }
}
</style>

<style lang="scss">
.records-tags__content {
  border-radius: 8px;
}

.records-tags__btn {
  &.selected {
    background-color: #7a8189 !important;
    border-color: #7a8189 !important;
    color: #fff;

    .tag-icon {
      svg {
        fill: #7a8189;

        path {
          fill: #fff;
        }
      }
    }
  }
}
</style>
